<form autocomplete="off" [formGroup]="form" (ngSubmit)="save()">
    <h4>Detalle de fuente primaria</h4>
    <hr>
    <div class="form-group row">

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Título</label>
            <input class="form-control" placeholder="Título" formControlName="title"
                [class.is-invalid]="campoNoValido('title')" type="text">
            <small class="text-danger" *ngIf="campoNoValido('title')">Este campo es requerido</small>

        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">URL</label>
            <input class="form-control" type="text" placeholder="URL" formControlName="url"
                [class.is-invalid]="campoNoValido('url')" autocomplete="off">
            <small class="text-danger" *ngIf="campoNoValido('url')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Estado</label>
            <div class="label-container align-switch">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="switch1" formControlName="status">
                </div>
            </div>
        </div>

    </div>


    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block" (click)="cancel()">
                        Cancelar
                    </button>
                </div>
                <ng-container *ngIf="!isBlockedTier3">
                    <button type="submit" class="btn btn-outline-primary">Guardar</button>
                </ng-container>
            </div>
        </div>
    </div>

</form>